import { useTranslation } from "react-i18next";
import WasteFlowFormPanel from "../../settings/waste/WasteFlowFormPanel";
import WasteFlowDateField from "../../settings/waste/WasteFlowDateField";
import WasteFlowNativeSelect from "../../settings/waste/WasteFlowNativeSelect";
import {
  WASTE_FORM_LABEL_CLASS,
  WASTE_FORM_REQUIRED,
} from "../../settings/waste/wasteFlowFormUi";
import CampaignZoneField from "./CampaignZoneField";

const CampaignGeneralInfoCard = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  addressId,
  onAddressChange,
  addressList,
  containers,
  containerObjectIdList,
  onContainerChange,
}) => {
  const { t } = useTranslation();

  return (
    <WasteFlowFormPanel title={t("campaign.generalInfoTitle")}>
      <div className="waste-flow-form-field__row waste-flow-form-field__row--dates">
        <WasteFlowDateField
          id="campaign-start-date"
          label={t("campaign.startDateLabel")}
          value={startDate}
          onChange={onStartDateChange}
          required
        />
        <WasteFlowDateField
          id="campaign-end-date"
          label={t("campaign.endDateLabel")}
          value={endDate}
          onChange={onEndDateChange}
          required
        />
      </div>

      <WasteFlowNativeSelect
        id="campaign-waste-origin"
        label={t("campaign.wasteOriginLabel")}
        value={addressId || ""}
        onChange={(event) => onAddressChange(event.target.value)}
        required
      >
        {addressList.length === 0 ? (
          <option value="">{t("No addresses available")}</option>
        ) : null}
        {addressList.map((address) => (
          <option key={address._id} value={address._id}>
            {address.name}
          </option>
        ))}
      </WasteFlowNativeSelect>

      <div className="waste-flow-form-field">
        <span className={WASTE_FORM_LABEL_CLASS}>
          {t("campaign.zoneLabel")} {WASTE_FORM_REQUIRED}
        </span>
        <CampaignZoneField
          containers={containers}
          selectedIds={containerObjectIdList}
          onChange={onContainerChange}
          disabled={!addressId}
        />
      </div>
    </WasteFlowFormPanel>
  );
};

export default CampaignGeneralInfoCard;
